import { defineComponent as d, h as e, Fragment as u } from "vue";
import m from "./ghl-ui.es1321.js";
import f from "./ghl-ui.es1319.js";
import l from "./ghl-ui.es1452.js";
import { isDividerNode as s } from "./ghl-ui.es1323.js";
import { warn as a } from "./ghl-ui.es859.js";
const g = d({
  name: "NDropdownGroup",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    },
    parentKey: {
      type: [String, Number],
      default: null
    }
  },
  render() {
    const { tmNode: o, parentKey: i, clsPrefix: t } = this, { children: n } = o;
    return e(
      u,
      null,
      e(l, { clsPrefix: t, tmNode: o, key: o.key }),
      n == null ? void 0 : n.map((r) => {
        const { rawNode: p } = r;
        return p.show === !1 ? null : s(p) ? e(f, {
          clsPrefix: t,
          key: r.key
        }) : r.isGroup ? (a("dropdown", "`group` node is not allowed to be put in `group` node."), null) : e(m, { clsPrefix: t, tmNode: r, parentKey: i, key: r.key });
      })
    );
  }
});
export {
  g as default
};
